module.exports = __webpack_public_path__ + "img/service-icon-4.b303cd5f.png";